<script setup>
import { computed } from 'vue'
import { format } from '@formkit/tempo'
import Button from '@components/forms/Button.vue'

const props = defineProps({
	gallery: {
		type: Object,
		required: true,
	},
})

const gameNames = computed(() => props.gallery.games?.map((game) => game.name_short).join(', '))
</script>

<template>
	<div class="relative flex w-full flex-col gap-3 overflow-hidden rounded-xl bg-black p-2 text-white lg:flex-row">
		<div class="grid aspect-video grid-cols-2 gap-2 lg:h-60">
			<template v-if="gallery.preview.length < 3">
				<img class="col-span-2 h-full w-full overflow-hidden rounded-lg object-cover" :src="gallery.preview[0]" :alt="gallery.title" />
			</template>
			<template v-else>
				<img class="h-full w-full overflow-hidden rounded-lg object-cover" :src="gallery.preview[0]" :alt="gallery.title" />
				<div class="flex flex-col gap-2">
					<img class="aspect-video h-fit w-full overflow-hidden rounded-lg object-cover" :src="gallery.preview[1]" :alt="gallery.title" />
					<img class="aspect-video h-fit w-full overflow-hidden rounded-lg object-cover" :src="gallery.preview[2]" :alt="gallery.title" />
				</div>
			</template>
		</div>
		<div class="flex grow flex-col justify-between gap-5 p-3 lg:h-60">
			<div class="flex flex-row items-start justify-between gap-2">
				<h6 class="w-5/6 leading-none">{{ gallery.title }}</h6>
				<div class="flex items-center justify-center gap-2 rounded-md bg-snk-dark-200 px-2 py-1.5">
					<div class="mt-1 font-poppins text-sm font-semibold">+{{ gallery.media_count }}</div>
					<i class="fas fa-image" />
				</div>
			</div>
			<div class="flex flex-col gap-2">
				<div class="flex flex-row items-center gap-2">
					<i class="fas fa-clock text-snk-blue-500"></i>
					<div class="text-nowrap text-sm font-semibold uppercase leading-tight">{{ format(gallery.start_at, 'medium', 'UTC') }} - {{ format(gallery.finish_at, 'medium', 'UTC') }}</div>
				</div>
				<div class="flex flex-row items-center gap-2" v-if="gallery.country">
					<i class="fas fa-location-dot text-snk-blue-500"></i>
					<div class="text-nowrap text-sm font-semibold uppercase leading-tight">{{ gallery.country.name }}</div>
				</div>
				<div class="flex flex-row items-center gap-2" v-if="gallery.games?.length">
					<i class="fas fa-joystick text-snk-blue-500"></i>
					<div class="text-wrap text-sm font-semibold uppercase leading-tight">{{ gameNames }}</div>
				</div>
			</div>
			<div class="hidden gap-2">
				<Button iconLeft="far fa-image" class="primary solid wide" :to="{ name: 'media', params: { slug: gallery.slug } }">View Media</Button>
			</div>
			<div class="flex flex-col gap-2">
				<Button iconLeft="far fa-image" class="primary solid wide thin" :to="{ name: 'media', params: { slug: gallery.slug } }">View Media</Button>
			</div>
		</div>
	</div>
</template>
